/* 🤖 this file was generated by script */
export const wiconRefreshCcw01 = {
  name: 'refresh_ccw_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2 10s2-2.73 3.63-4.36a9 9 0 11-2.28 8.86M2 10V4m0 6h6"/></svg>`,
};
